import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Skeleton, Row, Card, Col, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { generalPetsittingAddressInfo } from '../../../../../components/PetsittingAddress/listContent/petsittingAddressInfo';
import { DescriptionList } from '../../../../../components';
import PetsittingAddressInfoModal from '../modals/PetsittingAddressModal';
import { Carousel } from '../../../../../components/Carousel/Carousel';
import { useOwnerContext } from '../../../../../contexts/OwnerContext/OwnerContext';
import { CardTitle } from '../../../../../components/CardTitle/CardTitle';

/**
 * `PetsittingAddressInfoCards` is a component that displays information about a pet-sitting address,
 * including a carousel of photos and a description list with additional details.
 * It also manages a modal which can be opened to view more details.
 *
 * @component
 * @param {Object} props - The properties passed down from the parent component.
 * @param {boolean} props.isLoading - A boolean flag to indicate whether data is currently being loaded.
 *
 * @returns {React.Element} JSX representation of the component.
 */
const PetsittingaddressInfoCards = ({ isLoading }) => {
  const { t } = useTranslation();
  const { owner } = useOwnerContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Row gutter={[12, 12]}>
        <Col xs={24} xxl={24}>
          <Card
            title={
              <CardTitle icon="home">
                {t('owners.show.petsitting_address_info')}
              </CardTitle>
            }
            className="form-card"
            extra={
              <Button onClick={() => setIsModalOpen(true)} size="small">
                {t('owners.buttons.show_more')}
              </Button>
            }
          >
            <Row gutter={[24, 24]}>
              <Col xs={24} md={8}>
                <Carousel
                  imagesIds={owner?.petsitting_address?.dwelling_photos}
                />
              </Col>
              <Col xs={24} md={16}>
                <Skeleton active loading={isLoading} paragraph={{ rows: 5 }}>
                  <DescriptionList
                    data={generalPetsittingAddressInfo(
                      owner?.petsitting_address || {},
                      t
                    )}
                    translate
                  />
                </Skeleton>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <PetsittingAddressInfoModal
        address={owner?.petsitting_address}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        t={t}
      />
    </>
  );
};

export default PetsittingaddressInfoCards;

PetsittingaddressInfoCards.propTypes = {
  isLoading: PropTypes.bool
};

PetsittingaddressInfoCards.defaultProps = {
  isLoading: false
};
